module.exports = __webpack_public_path__ + "static/media/fasad4.19770e50.jpeg";